export function StartWorkerInterval(fps, callback) {
  let interval;
  interval = new Worker('js/worker.js');
  interval.postMessage(fps);
  interval.addEventListener(
    'message',
    function (e) {
      callback(e);
    },
    false,
  );

  return interval;
}

export function StopWorkerInterval(interval) {
  if (interval != null) {
    interval.postMessage('stop');
    interval.terminate();
    interval = null;
  }
}
